import { axiosInstance, baseUrl, handleErrors } from "./auth";


//  Form List
export const GET_FORM_LIST = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/form/list`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
}

// GET_FORM_DETAILS
export const GET_FORM_DETAILS = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseUrl}/form/getDetails/${params}`);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
}

// FORM_FILL
export const FORM_FILL = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/form/fill`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
}

// SHARE MEDICAL HISTORY FORM ------------------
export const SHARE_MEDICAL_HISTORY_FORM = async (params) => {
    try {
        let response = await axiosInstance.post(`${baseUrl}/form/share`, params)
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
}


// ADD AND FILL FORM ------------------
export const ADD_AND_FILL_FORM = async (params) => {
    try {
        let response = await axiosInstance.post(`${baseUrl}/form/addAndFillForm`, params)
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
}



// consent Form List
export const GET_CONSENT_FORM_LIST = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/consentForm/list`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
}


// GET_CONSENT_FORM_DETAILS
export const GET_CONSENT_FORM_DETAILS = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseUrl}/consentForm/getDetails/${params}`);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
}

// FORM_FILL
export const CONSENT_FORM_FILL = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/consentForm/fill`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
}
// SHARE MEDICAL HISTORY FORM ------------------
export const SHARE_CONSENT_FORM = async (params) => {
    try {
        let response = await axiosInstance.post(`${baseUrl}/consentForm/share`, params)
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
}